// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

var PaymentsExportController = function ($rootScope, $scope, $http, $location, BlEbicsAvailabilityService, PaymentExportService)
{
    $scope.exportFormats =  PaymentExportService.getPaymentExportFormats(); 
    $scope.selectedFormat = $scope.exportFormats[0];

    BlEbicsAvailabilityService.requestEbicsAvailableFlag(function (available) {
        if (available && canUserCreateExportOrSendToBank())
            PaymentExportService.getEbicsAutomaticProcessingSettings().then(function (response) {
                $scope.ebicsAutomaticProcessingSettings = response.data;
            });
    });

    PaymentExportService.getSepaXmlExportFormats().then(function (response) {
        if(response.data.DebitTransferPaymentExportFormat) {
            const index = $scope.exportFormats.findIndex(x => x.id === response.data.DebitTransferPaymentExportFormat);
            if(index >= 0) {
                $scope.selectedFormat = $scope.exportFormats[index];
            }
        }
    });    

    $scope.isExportDisabled = function() {
        if(!canUserCreateExportOrSendToBank()){
            return true;
        }

        if(!BlEbicsAvailabilityService.isEbicsAvailable()) {
            return false;
        }

        if($scope.ebicsAutomaticProcessingSettings) {
            return $scope.ebicsAutomaticProcessingSettings.UploadSepaXmlAutomatically;
        }
        return false;
    }

    $scope.export = function () {
        $http({
            method: "POST",
            url: "/api/v1/paymentsExports/" + $scope.selectedFormat.id,
            params: {},
            //data: parameters,
            headers: {},
            cache: false
        }).then(function () {
            $location.path("/activities/payments-export-files");
        });
    };

    $scope.sendToBank = function () {
        $http({
            method: "POST",
            url: "/api/v1/paymentsExports/" + $scope.selectedFormat.id + "/sendToBank",
            params: {},
            headers: {},
            cache: false
        }).then(function () {
            $location.path("/activities/payments-export-files");
        });
    };    

    $scope.isSentToBankShown = function() {
        return BlEbicsAvailabilityService.isEbicsAvailable() && canUserCreateExportOrSendToBank();
    }
    
    function canUserCreateExportOrSendToBank() {
        return $rootScope.adminOrInRole(["Operations", "Finance"]);
    }    
    
};
PaymentsExportController.$inject = ["$rootScope", "$scope", "$http", "$location", "BlEbicsAvailabilityService", "PaymentExportService"];
